"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineAutomationService = void 0;
//ANGULAR 2 BITS
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
const websocket_service_1 = require("./websocket.service");
const token_service_1 = require("./token.service");
const notification_service_1 = require("./notification.service");
const system_notification_service_1 = require("./system-notification.service");
const notifier_service_1 = require("./notifier.service");
let LineAutomationService = class LineAutomationService {
    constructor(_webSocket, _http, _talk, _liaNotifications, _router, _notifier) {
        this._webSocket = _webSocket;
        this._http = _http;
        this._talk = _talk;
        this._liaNotifications = _liaNotifications;
        this._router = _router;
        this._notifier = _notifier;
        this.connected = false;
        this.serviceStarted = false;
        this.lineAutomationUrl = '/lineautomation/run';
        this.lineItemDfpConfigUrl = '/lineitemdfp';
        this.onSocketEvent = () => { };
        this.onSocketConnectionOrError = new core_1.EventEmitter;
        this.socketDisconnectCount = 0;
        this.connect();
    }
    connect() {
        if (!this.connected) {
            this._webSocket.connectSocket()
                .subscribe({
                next: this.onSocketConnectionOrErrorEvent.bind(this)
            });
        }
    }
    /**
     * Starts a Socket Request for the line item automation service
     * @param {{args: any; script?: string; roomName?: string; promptResponse?: any}} data
     * @param {{fn: Function; context: any}} callOnEvent
     */
    start(data, callOnEvent) {
        this._webSocket.request({
            method: 'POST',
            url: this.lineAutomationUrl,
            data,
            headers: this._http.createNewAuthHeaders()
        }).subscribe({
            next: (response) => {
                this.serviceStarted = true;
                //Set function to execute on event
                try {
                    this.subscribeSocketEvents(response.data.broadcastEvtId, callOnEvent);
                }
                catch (error) {
                    console.error('Unable to subscribe to event', error);
                }
            },
            error: (error) => {
                this.handleSocketSubscriptionError(error, data);
            }
        });
    }
    /**
     * Allows to register a Function function to be called when Sockets events are received;
     * It will be called with socket Event received
     */
    registerOnSocketEvent(fn) {
        this.onSocketEvent = fn;
    }
    /**
     * Subscribe the given callOnEvent fn to the the given broadcastEvent Id
     * @param {string} broadcastEvtId
     * @param {{fn: Function; context: any}} callOnEvent
     */
    subscribeSocketEvents(broadcastEvtId, callOnEvent) {
        if (this.serviceStarted) {
            //Subscribe to this event to the socket Function and run appropriate operation based on event status
            this._webSocket.on(broadcastEvtId).subscribe({
                next: (callOnEvent) ? callOnEvent.fn.bind(callOnEvent.context) : this.onSocketEvent
            });
        }
        else {
            throw new Error(`LineItemAutomationService: Unable to subscribe events for eventID(${broadcastEvtId}). Service is not connected or started`);
        }
    }
    /**
     * Triggers Read_DFp to get the DFP values for given commandName
     * @param {string} commandName
     * @param {number} dfpNetworkCode
     * @param {{fn: Function; context: any}} callOnEvent - The fn: function the will called when a event is received
     * @param {number} companyId
     * @param {string[]} adunitNames
     * @returns {any}
     */
    readDfpValues(data) {
        if ((data.commandName === 'orders' || data.commandName === 'creatives') && !data.companyId) {
            console.warn('Unable to get DFP Values. Company ID is required to retrieve order or creatives', data.commandName, data.dfpNetworkCode, data.companyId);
            return;
        }
        let args = {
            dfpNetworkCode: data.dfpNetworkCode
        };
        let optionalValues = ['companyId', 'adunitNames', 'pql', 'creativeIds', 'orderIds'];
        //Verify for optional args
        optionalValues.forEach(optKey => { if (data[optKey])
            args[optKey] = data[optKey]; });
        return this.start({
            args: {
                command: data.commandName,
                args: [args]
            },
            script: 'read_dfp',
            bidder: data.bidder
        }, data.callOnEvent);
    }
    /**
     * Get the line item config values from DB
     * @param {number} bidder
     * @param {string} fields optional fields to be retrieve Ex: "orderIds;creativeIds"
     * @returns {Promise<Object | LineItemDfpConfig>}
     */
    getDfpConfigValues(bidder, fields) {
        let queryStr = `bidder=${bidder}`;
        if (fields)
            queryStr += `&fields=${fields}`;
        return this._http.get(`${this.lineItemDfpConfigUrl}/get?${queryStr}`)
            .toPromise()
            .then(response => this.castRequiredKeysToInt(response.json() || null))
            .catch(error => { throw new Error(`Unable to get line items config values. Error ${error.message}`); });
    }
    /**
     * Update or create/save the config values for given bidder
     * @param {number} bidder
     * @param configValues
     * @returns {Promise<T>}
     */
    updateDfpConfigValues(bidder, configValues) {
        return this._http.post(`${this.lineItemDfpConfigUrl}/update/${bidder}`, Object.assign({}, configValues))
            .toPromise()
            .then(response => {
            return this.castRequiredKeysToInt(this.excludeFields(response.json()[0]) || null);
        })
            .catch(responseError => {
            if (responseError.status === 404) { //bidder values do not exist so create
                return this.createDfpConfigValues(bidder, configValues);
            }
            //Let our caller catch the error. Throwing new error so Async/Await caller can catch error
            throw new Error(`Unable to update config values . Response Status: ${responseError.statusText}`);
        });
    }
    /**
     * Create new config values for bidder
     * @param {number} bidder
     * @param configValues
     * @returns {Promise<Error | T>}
     */
    createDfpConfigValues(bidder, configValues) {
        return this._http.post(this.lineItemDfpConfigUrl, Object.assign({ bidder: parseInt(bidder + '') }, configValues))
            .toPromise()
            .then(response => { return this.castRequiredKeysToInt(this.excludeFields(response.json()) || null); })
            .catch(responseError => { throw new Error(`Unable to create line items config values.Status Error: ${responseError.statusText}`); });
    }
    /**
     * Get the Dfp Network Codes from organization of current user on session
     * @returns {number[]}
     */
    getDfpNetworks(orgId) {
        return this._http.get(`/organization/${orgId}`)
            .toPromise()
            .then(response => {
            let data = response.json();
            if (data && data.dfpNetworkCodes)
                return data.dfpNetworkCodes;
            return [];
        });
    }
    addDfpNetwork(networkData) {
        return this._http.post(`/dfpNetworkCode`, networkData)
            .toPromise()
            .then(response => response.json());
    }
    deleteDfpNetwork(networkId) {
        return this._http.delete(`/dfpNetworkCode/${networkId}`)
            .toPromise()
            .then((response) => { return response.json(); });
    }
    updateDfpNetwork(networkId, data) {
        return this._http.put(`/dfpNetworkCode/${networkId}`, data)
            .toPromise()
            .then((response) => { return response.json(); });
    }
    /**
     * Cast the given obj values keys that match the keysToParse into number
     * @param obj Object to cast values to number
     * @returns {any}
     */
    castRequiredKeysToInt(obj, keysToParse) {
        if (!obj || !(Object.prototype.toString.call(obj) === '[object Object]'))
            return obj;
        keysToParse = keysToParse || ["companyId", "dfpNetworkCode"];
        keysToParse.forEach((key) => {
            if (obj.hasOwnProperty(key) && obj[key] && typeof obj[key] !== 'number') {
                obj[key] = Number(obj[key]);
            }
        });
        return Object.assign({}, obj);
    }
    /**
     * Exclude the given properties fields from the given source object
     * Main purpose of this function is to remove certain fields from Sails Blueprint update and create without having to
     * write the custom endpoints on the backend;
     * @param source : Object
     * @param {string[]} fieldsToExclude
     * @returns {any}
     */
    excludeFields(source, fieldsToExclude) {
        if (!source || !(Object.prototype.toString.call(source) === '[object Object]'))
            return source;
        let sourceCopy = Object.assign({}, source);
        fieldsToExclude = fieldsToExclude || ['updatedAt', 'createdAt', 'state'];
        fieldsToExclude.forEach((fieldName) => {
            if (sourceCopy.hasOwnProperty(fieldName)) {
                delete sourceCopy[fieldName];
            }
        });
        return sourceCopy;
    }
    copyUpdatedValues(receiver, updatedValues) {
        if (updatedValues) {
            for (let value in updatedValues) {
                receiver[value] = updatedValues[value];
            }
        }
        return receiver;
    }
    /**
     * Receives connectivity events from web socket connection
     * @param {Object} event
     */
    onSocketConnectionOrErrorEvent(event) {
        this.connected = !!event.connected;
        if (!event.connected) {
            this.socketDisconnectCount++;
        }
        else if (event.connected && this.socketDisconnectCount > 0) {
            // if the socket is now connected after being disconnected
            // we must re-register the LIA socket room so that any 
            // current observers received new incoming events
            this.registerSocketRoom();
            this.socketDisconnectCount = 0;
        }
        // notify internal LIA service observers of connection change
        this.onSocketConnectionOrError.emit({ type: 'connection', connected: !!event.connected });
    }
    registerSocketRoom() {
        this._webSocket.request({
            method: 'POST',
            url: '/lineautomation/register',
            headers: this._http.createNewAuthHeaders()
        }).subscribe({
            next: (response) => {
                console.log('LIA Room registration subcription', response.data);
            },
            error: (err) => {
                console.log('LIA Room registration subcription err', err);
            }
        });
    }
    retryDfpVerificationHandler(bidder, notificationId) {
        return function () {
            this._router.navigate(['controlcenter/edit', bidder], { queryParams: { retryLiaVerify: true } })
                .then(nav => {
                if (!nav) {
                    this._talk.broadcast(`<p>Oops! we are unable to continue DFP Verification for this bidder. The bidder config settings may not longer be available.</p>`);
                }
                // stop and delete notification
                if (notificationId) {
                    this._notifier.stop(notificationId, true);
                }
            });
        }.bind(this);
    }
    deleteCacheFile(bidder) {
        return this._http.post('/lineautomation/deleteCache', { bidder }).toPromise()
            .then(res => res.json());
    }
    handleSocketSubscriptionError(error, data) {
        let serviceName = 'Line Item Automation';
        if (data.script === 'dfp_verify')
            serviceName += ' DFP Verification';
        this._notifier.start({
            title: 'Line Item Automation',
            id: `LIA-${data.bidder}`,
            status: `Unable To Run ${serviceName} for Bidder(${data.bidder})`,
            error: (typeof error.data === 'string') ? error.data : 'Internal Server Error',
            type: 'error'
        });
        //Display a more friendly error to user
        switch (error.data) {
            case 'LineAutomationRequestLimitReached':
                this._talk.broadcast(`
        <h1>${serviceName} Requests Limit Reached</h1>
        <p>You have reached the total limit of 10 line item automation requests for your current session. 
        Please reach out to our support team for further assistance.</p>
        `);
                break;
            case 'ServiceRequestInQueued':
            case 'ServiceRequestInQueuedForDfpNetworkCode':
                this._talk.broadcast(`
          <h1>Unable To Run ${serviceName}</h1> 
          <p>There is already a line item automation process running for bidder(${data.bidder}) or DFP Network Code(${data.args.args[0].dfpNetworkCode}). 
          You can only run 1 line item automation service request per bidder and DFP Network Code.</p>`);
                break;
            default:
                //console.error('LineItemAutomation-- Socket Request Error', error);
                this._talk.broadcast(`
          <h1> Oops! We had an Internal Server Error</h1>
          <p>We experienced some problem processing this ${serviceName} Request. 
          If you continue to experience this problem, please Submit a support request.</p>`);
        }
        // notify error observers
        this.onSocketConnectionOrError.emit({ type: 'error', error, data });
    }
    /**
     * Only allow logging debug data for non prod environments
     */
    canLogDebugData() {
        return this._webSocket.getServerEnv() !== 'gen-prod';
    }
};
exports.LineAutomationService = LineAutomationService;
exports.LineAutomationService = LineAutomationService = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [websocket_service_1.WebSocketService,
        token_service_1.TokenService,
        notification_service_1.NotificationService,
        system_notification_service_1.SystemNotificationService,
        router_1.Router,
        notifier_service_1.NotifierService])
], LineAutomationService);
//# sourceMappingURL=lineitem-automation.service.js.map